import React from 'react'
import classNames from 'classnames'

const gridColsClasses: Record<number, string> = {
  1: 'sm:grid-cols-1',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3',
  4: 'sm:grid-cols-4',
  5: 'sm:grid-cols-5',
  6: 'sm:grid-cols-6',
}

interface GridCardProps {
  children?: React.ReactNode
  cols?: number
  containerClassNames?: string
  itemClassNames?: string
  overflowVisible?: boolean
}

export default function GridCard({
  children,
  cols = 2,
  containerClassNames = '',
  itemClassNames = '',
  overflowVisible = false
}: GridCardProps) {
  const childrenArray = Array.isArray(children)
    ? children
    : [children]
  return (
    <>
      {children && (
        <div
          className={`${containerClassNames} ${overflowVisible ? '' : 'overflow-hidden'} divide-y divide-gray-200 rounded-lg bg-gray-200 border sm:grid ${gridColsClasses[cols] ?? 'sm:grid-cols-2'} sm:gap-px sm:divide-y-0`}>
          {childrenArray.map((child, actionIdx) => (
            <div
              key={`cell-${actionIdx}`}
              className={classNames(
                actionIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '',
                actionIdx === cols - 1 ? 'sm:rounded-tr-lg' : '',
                actionIdx === childrenArray.length - cols ? 'sm:rounded-bl-lg' : '',
                actionIdx === childrenArray.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '',
                `bg-white p-6 ${itemClassNames}`
              )}
            >
              {child}
            </div>
          ))}
        </div>
      )}
    </>
  )
}
